import React from 'react'
import classNames from 'classnames';
import { CGE } from '..';

function Button(props) {

  !props.disabled ? props.disabled = false : props.disabled = props.disabled;
  !props.type ? props.type = "primary" : props.type = props.type;

  if (props.href) {

    let linkHref = props.href;

    if (props.blank) {
      props.onClick = () => window.open(linkHref, "_blank");
    } else {
      props.onClick = () => window.location.href = linkHref;
    }
  }

  return (
    <button
      className={classNames(
        'cge-button', props.className,
        {
          'cge-button-secondary': props.type === "secondary",
          'cge-button-primary': props.type === "primary",
          'cge-button-ghost': props.type === "ghost",
          'cge-button-primary cge-button-icon-cicle': props.type === "only-icon-cicle",
          'cge-button-only-icon': props.icon && !props.label,
          'cge-button--sm': props.size === "sm",
        }
      )}
      onClick={props.onClick}
      disabled={props.disabled}
      type={props.typeButton}
    >

      {props.leftIcon &&
        <i class={"icon-" + props.leftIcon} />
      }

      <CGE.Text text={props.label} className="mb-0" />

      {props.icon &&
        <i class={"icon-" + props.icon} />
      }

      {props.rightIcon &&
        <i class={"icon-" + props.rightIcon} />
      }

    </button>
  )
}

export default Button